import { useFragment } from "@/generated";
import { DeleteVocabCardDocument, VocabCardFieldsFragmentDoc } from "@/generated/graphql";
import { withToast } from "@/lib/utils/withToast";
import { useMutation } from "@apollo/client/react";

export function useDeleteVocabCards() {
  const [deleteVocabCardsMutation, { loading, error }] = useMutation(DeleteVocabCardDocument, {
    update(cache, { data }) {
      if (!data?.deleteVocabCard) return;

      const deletedVocabCard = useFragment(VocabCardFieldsFragmentDoc, data.deleteVocabCard);

      for (const card of deletedVocabCard) {
        const cacheId = cache.identify(card);
        if (cacheId) cache.evict({ id: cacheId });
      }
    },
  });

  const deleteVocabCards = (ids: string[]) => {
    const title = ids.length > 1 ? "cards" : "card";

    withToast(
      async () => {
        return await deleteVocabCardsMutation({
          variables: {
            ids,
          },
        });
      },
      {
        success: `${ids.length} vocabulary ${title} deleted`,
        error: "Failed to delete vocabulary card",
        loading: `Deleting ${ids.length} vocabulary ${title}`,
      },
      "delete-vocabCard-toast"
    );
  };

  return {
    deleteVocabCards,
    loading,
    error,
  };
}
